<script setup lang="ts">
const props = defineProps<{
  title: string;
  value: number | string;
  icon: string;
  to?: string;
}>();
</script>

<template>
  <component
    :is="props.to ? 'router-link' : 'div'"
    :to="props.to"
    class="stats-card px-3 py-2 d-flex flex-column justify-content-center"
    :class="{ clickable: props.to }"
  >
    <div class="d-flex align-items-center justify-content-between gap-4">
      <span class="fw-medium title">{{ props.title }}</span>
      <i class="bi" :class="props.icon"></i>
    </div>
    <span class="fw-semibold fs-2 value">{{ props.value }}</span>
  </component>
</template>

<style lang="scss" scoped>
@import "../theme/variables";

.stats-card {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;

  max-width: 250px;
  gap: 10px;
  width: 100%;
  border-radius: 10px;
  justify-content: space-between;
  color: inherit;
  text-decoration: none;
  &.clickable {
    cursor: pointer;
    transition: transform 150ms ease;
    &:hover {
      transform: translateY(-2px);
    }
  }
  i {
    font-size: 25px;
    color: $blue;
    position: relative;
  }
  .title {
    font-size: 14px;
  }
}
.value {
  font-family: Arial, Helvetica, sans-serif;
}
</style>
